<template>
  <div class="login">
    <div class="header">
      <img class="logo" src="~@/assets/logo@2x.png" />
    </div>
    <group>
      <x-input
        title="手机号"
        name="phone"
        v-model="params.phone"
        placeholder="请输入手机号"
      >
      </x-input>

      <x-input
        title="验证码"
        type="number"
        placeholder="验证码"
        v-model="params.code"
      >
        <x-button
          @click.native="getCode"
          :disabled="isDisable"
          slot="right"
          type="primary"
          mini
          >{{ getMobileCodeText() }}</x-button
        >
        <!--<x-button @click.native="getCode" :disabled="countDown > 0" slot="right" type="primary" mini-->
        <!--&gt;发送验证码{{ countDown > 0 ? `(${countDown})`:'' }}</x-button-->
        <!--&gt;-->
      </x-input>
      <x-input
        title="密码"
        name=""
        v-model="params.password"
        type="password"
        placeholder="请输入密码"
      >
      </x-input>
      <x-input
        title="业务员手机号"
        type="number"
        placeholder="业务员手机号"
        v-model="params.traderPhone"
      >
      </x-input>
    </group>
    <div class="register-wrap">
      <p
        class="register"
        @click="() => $router.replace(`/login?authId=${$route.query.authId}`)"
      >
        用户登录
      </p>
    </div>
    <group style="padding: 0 24px;">
      <x-button
        class="login-btn"
        @click.native="goStep1"
        :show-loading="loading"
        type="primary"
        >激活</x-button
      >
    </group>
  </div>
</template>
<script>
import { XInput, Group, XButton } from "vux";
import { mapActions } from "vuex";
import { registerClient, fetchCode } from "../../api/client";
import { validatePhone } from "@/utils/validate-util";

export default {
  components: { XInput, Group, XButton },
  data() {
    return {
      params: {
        code: "",
        password: "",
        phone: "",
        traderPhone: ""
      },
      loading: false,
      show: false,
      menus: [],
      redirectUrl: "/",
      countDown: 0,
      wait_timer: false,
      isDisable: false
    };
  },
  created() {},
  methods: {
    ...mapActions(["commonLogin"]),
    count(id) {
      if (id > 0) {
        this.countDown = id;
        setTimeout(() => {
          this.count(id - 1);
        }, 1000);
      }
    },
    getMobileCodeText() {
      if (this.wait_timer > 0) {
        return this.wait_timer + "s后获取";
      }
      if (this.wait_timer === 0) {
        return "重新获取";
      }
      if (this.wait_timer === false) {
        return "获取验证码";
      }
    },
    getCode() {
      if (!this.params.phone || !validatePhone(this.params.phone)) {
        this.$showError("请输入手机号");
        return;
      }
      let that = this;
      fetchCode({
        phone: this.params.phone,
        type: 1
      })
        .then(() => {
          this.wait_timer = 59;
          this.isDisable = true;
          let timer_interval = setInterval(function() {
            if (that.wait_timer > 0) {
              that.wait_timer--;
            } else {
              that.isDisable = false;
              clearInterval(timer_interval);
            }
          }, 1000);
        })
        .catch(err => {
          this.$vux.toast.text(err);
        });
    },
    goStep1() {
      this.loading = true;
      const params = {
        ...this.params,
        authorizeId: this.$route.query.authId
      };
      registerClient(params)
        .then(res => {
          this.loading = false;
          this.commonLogin(res);
          this.$router.push("/profile/step1");
        })
        .catch(err => {
          this.loading = false;
          this.$vux.toast.text(err);
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import "~@/styles/theme.less";
.title {
  color: @theme-color;
}
.header {
  text-align: center;
  padding: 137px 0;
  .logo {
    width: 480px;
  }
}
.login-btn {
  background: linear-gradient(0deg, rgba(0, 109, 255, 1), rgba(0, 156, 255, 1));
}
.gologin {
  display: block;
  float: left;
  margin-left: 48px;
  font-size: 14px;
  color: #525252;
}
.register {
  text-align: right;
  display: block;
  margin-left: 48px;
  font-size: 12px;
  color: #1959c9;
  &-wrap {
    padding: 10px 50px;
    overflow: hidden;
  }
}
.code {
  width: 200px;
  height: 46px;
  line-height: 46px;
  background-color: #fff;
  border: 1px solid #039df8;
  color: #039df8;
  display: block;
  margin: 18px 20px;
  border-radius: 25px;
  float: right;
  font-size: 12px;
  text-align: center;
}
</style>
